import React from "react";
import BootcampPage from "./BootcampPage";
import AboutBootcamp from "./AboutBootcamp";
import LearningRoadmap from "./LearningRoadmap";
import Opportunity from "./Opportunity";
import Learner from "./Learner";
import FAQ from "./FAQ";
import DiscoverBootcamps from "./DiscoverBootcamps";
// import ThirtyDaysLanding from './30DaysPage/ThirtyDaysLanding'
// import BootcampPage from './BootcampPage'

function LandindPage() {
  return (
    <div className="">
      <div className="App">
        <BootcampPage />
        <div id="overview"><AboutBootcamp /></div>
        <div id="roadmap"><LearningRoadmap /></div>
        <div id="requirements"><Opportunity /></div>
        <div id="reviews"><Learner /></div>
        <div id="faq"><FAQ /></div>
        <DiscoverBootcamps />
      </div>
    </div>
  );
}

export default LandindPage;
